<template>
  <div id="app">
    <Dashboard v-if="layout === 'dashboard'"></Dashboard>
    <Blank v-else></Blank>
  </div>
</template>

<script>
import Dashboard from './layout/Dashboard'
import Blank from './layout/Blank'
export default {
  name: 'DcMainFrame',
  components: { Dashboard, Blank },
  data() {
    return {
      layout: 'dashboard'
    }
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        if (!localStorage.token) return (this.layout = 'blank')
        if (newValue !== oldValue) {
          if (newValue.meta && newValue.meta.layout === 'blank') {
            this.layout = 'blank'
          } else {
            this.layout = 'dashboard'
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="stylus">
#app
  height 100%
</style>
